<template>
  <v-card
    height="110"
    :style="`border-radius: 5px; border-bottom: 5px solid ${bottomColor}`"
    :class="routePath.length ? 'clickable' : ''"
    @click="onClick"
  >
    <v-card-text>
      <h4 class="text-muted text-center box-text">{{ labelText }}</h4>
      <h3 class="text-center">
        {{ value }}
      </h3>
    </v-card-text></v-card
  >
</template>

<script>
export default {
  props: {
    labelText: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
    bottomColor: {
      type: String,
      default: "#ff3a3a",
    },
    routePath: {
      type: String,
      default: "",
    },
  },
  computed: {
    cardStyle() {
      let style = {
        borderRadius: "10px",
        borderBottom: `5px solid ${bottomColor}`,
      };
      return style;
    },
  },
  methods: {
    onClick() {
      if (!this.routePath.length) return;
      else router.push(this.routePath);
    },
  },
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
</style>
